import { render, staticRenderFns } from "./w-image-slider.vue?vue&type=template&id=0042ea08"
import script from "./w-image-slider.vue?vue&type=script&lang=js"
export * from "./w-image-slider.vue?vue&type=script&lang=js"
import style0 from "./w-image-slider.vue?vue&type=style&index=0&id=0042ea08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports